<template>
  <div>
    <v-row justify="center" style="margin-left: 1% !important">
      <v-layout class="overflow-visible" style="height: 56px">
        <v-bottom-navigation
          :elevation="24"
          v-model="selectedTab"
          color="rgb(204 33 40)"
          grow
          width="98% !important"
        >
          <v-btn value="usuarios">
            <v-icon>mdi-account-group</v-icon>
            Usuarios
          </v-btn>

          <v-btn value="roles">
            <v-icon>mdi-account-key</v-icon>
            Roles
          </v-btn>

          <v-btn value="permisos">
            <v-icon>mdi-shield-check</v-icon>
            Permisos
          </v-btn>
        </v-bottom-navigation>
      </v-layout>
    </v-row>

    <base-card>
      <v-card-text class="mt-3">
        <div class="py-6">
          <component :is="currentComponent" />
        </div>
      </v-card-text>
    </base-card>
  </div>
</template>

<script>
import RolesList from "@/views/app/user/RolesList.vue";
import PermissionsList from "@/views/app/user/PermissionsList.vue";
import UsersRolesPermissions from "@/views/app/user/UsersRolesPermissions.vue";

export default {
  name: "RolesAndPermissions",
  data() {
    return {
      selectedTab: "usuarios",
    };
  },
  computed: {
    currentComponent() {
      switch (this.selectedTab) {
        case "roles":
          return RolesList;
        case "permisos":
          return PermissionsList;
        case "usuarios":
          return UsersRolesPermissions;
        default:
          return RolesList;
      }
    },
  },
};
</script>
